/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { toSignedAngle } from 'shared/libs/utils/numbers';

const Actions = Object.freeze({
    DUPLICATE: 'duplicate',
    ROTATE_90_LEFT: 'rotate-90-left',
    FLIP_HORIZONTAL: 'flip-horizontal',
    FLIP_VERTICAL: 'flip-vertical',
});

const __vue_script__ = {
    name: 'ToolControls',

    props: {
        flipEnabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            Actions,
        };
    },

    methods: {
        handleToolClick(event) {
            const button = event.target.closest('button');
            const action = button?.dataset?.action;

            if (Actions.DUPLICATE === action) {
                return this.$emit('duplicate');
            }
            if (Actions.ROTATE_90_LEFT === action) {
                return this.$emit('change', { property: 'angle', value: toSignedAngle(this.value.angle - 90) });
            }
            if (Actions.FLIP_HORIZONTAL === action) {
                return this.$emit('change', { property: 'flipX', value: !this.value.flipX });
            }
            if (Actions.FLIP_VERTICAL === action) {
                return this.$emit('change', { property: 'flipY', value: !this.value.flipY });
            }
        },
    },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-controls form-group"},[_c('label',{staticClass:"label-control"},[_vm._v(_vm._s(_vm.$t('badge_editor.parameters.tools')))]),_c('div',{staticClass:"param-group",on:{"click":_vm.handleToolClick}},[_c('button',{staticClass:"btn btn-ctx-icon btn-primary",attrs:{"data-action":_vm.Actions.DUPLICATE,"title":_vm.$t('badge_editor.duplicate')}},[_c('i',{staticClass:"icon ic-copy"})]),_c('button',{staticClass:"btn btn-ctx-icon btn-primary",attrs:{"data-action":_vm.Actions.ROTATE_90_LEFT,"title":_vm.$t('badge_editor.rotate_90_left')}},[_c('i',{staticClass:"icon ic-cycle"})]),(_vm.flipEnabled)?_c('button',{staticClass:"btn btn-ctx-icon btn-primary",attrs:{"data-action":_vm.Actions.FLIP_HORIZONTAL,"title":_vm.$t('badge_editor.flip_horizontal')}},[_c('i',{staticClass:"icon ic-flip-horizontal"})]):_vm._e(),(_vm.flipEnabled)?_c('button',{staticClass:"btn btn-ctx-icon btn-primary",attrs:{"data-action":_vm.Actions.FLIP_VERTICAL,"title":_vm.$t('badge_editor.flip_vertical')}},[_c('i',{staticClass:"icon ic-flip-vertical"})]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ToolControls.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__